const Divider = () => {
  return (
    <div className="mx-auto my-1 h-[1.3px] w-11/12 bg-border-light dark:bg-border"></div>
  );
};

export default Divider;
